import React from 'react';
import { NavLink } from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

const useStyles = makeStyles((theme) => ({
  mobiledisplay: {
    [theme.breakpoints.down('xs')]: {
      display: 'none'
    }
  }
}));

export default function BackToSearch() {
  const classes = useStyles();

  return (
    <Box
      display='flex'
      alignItems='center'
      className={classes.mobiledisplay + ' no-print'}
    >
      <NavLink to='/search'>
        {/* IT IS IMPORTANT TO MOVE THE FRONTSEARCH FUNCTIONALITY TO THE SEARCH FUNCTIONALITY (DEFAULTSEARCHQUERYINFO), THE ORIGINAL RESET HAS TO RUN IF THE USER COMES FROM THE HOME PAGE (RESETTING THE SEARCH TERM AND THE CONTENT TYPES) USER WOULD EXPECT TO PRESS BACK BUTTON OR BACK TO SEARCH BUTTON AND HAVE THEIR ORIGINAL SEARCH TERM AND TYPES SHOW UP BUT IF THEY COME FROM THE HOME PAGE TO DO A NEW SEARCH THEY WOULD EXPECT TO SEE ALL CONTENT TYPES AND NO SEARCH TERM */}
        <IconButton aria-label='back'>
          <ArrowBackIcon color='secondary' />
        </IconButton>
      </NavLink>

      <Typography variant='overline'>To Search Page</Typography>
    </Box>
  );
}
